module.exports = __webpack_public_path__ + "img/00045.63bc38ba.webp";